<template>
    
    <div ref="dataprint" style="margin: 0 !important; padding: 0 !important;">
        <div style="width: 100%;  background: white; font-size: 11pt;">
            <div  style="display: flex; justify-content: center; margin-top: 1rem">
                <div> 
                    {{dataProps.data.user.business}}
                </div>
            </div>
            <div style="text-align: center; vertical-align: middle; width: 100%; font-size: 9pt;">RAZÓN SOCIAL: {{dataProps.data.branch.BusinessBillingName != undefined || dataProps.data.branch.BusinessBillingName != null ? dataProps.data.branch.BusinessBillingName.toUpperCase() : "--"}}</div>
            <div style="text-align: center; vertical-align: middle; width: 100%; font-size: 9pt;" v-if="dataProps.data.header.EmisorDescActividad">ACTIVIDAD: {{dataProps.data.header.EmisorDescActividad != undefined || dataProps.data.header.EmisorDescActividad != null ? dataProps.data.header.EmisorDescActividad.toUpperCase() : "--"}}</div>
            <div style="text-align: center; vertical-align: middle; width: 100%; font-size: 9pt;" v-if="dataProps.data.branch.BranchLegalAddress">DIRECCIÓN: {{dataProps.data.branch.BranchLegalAddress != undefined || dataProps.data.branch.BranchLegalAddress != null ? dataProps.data.branch.BranchLegalAddress.toUpperCase() : "--"}}</div>
            <div style="text-align: center; vertical-align: middle; width: 100%; font-size: 9pt;" v-if="dataProps.data.branch.BranchPhone">TÉLEFONO: {{dataProps.data.branch.BranchPhone || "--"}}</div>
            <div style="text-align: center; vertical-align: middle; width: 100%; font-size: 9pt;" v-if="dataProps.data.branch.BranchMobile">WHATSAPP: {{dataProps.data.branch.BranchMobile || "--"}}</div>
            <div style="text-align: center; vertical-align: middle; width: 100%; font-size: 9pt;" v-if="dataProps.data.branch.BranchEmail">E-MAIL: {{dataProps.data.branch.BranchEmail != undefined || dataProps.data.branch.BranchEmail != null ? dataProps.data.branch.BranchEmail.toUpperCase() : "--"}}</div>
            <div style="text-align: center; vertical-align: middle; width: 100%; font-size: 9pt;">NIT: {{dataProps.data.branch.BusinessBillingNIT != undefined || dataProps.data.branch.BusinessBillingNIT != null ? dataProps.data.branch.BusinessBillingNIT.toUpperCase() : "--"}}</div>
            <div style="text-align: center; vertical-align: middle; width: 100%; font-size: 9pt;">NRC: {{dataProps.data.branch.BusinessBillingNRC != undefined || dataProps.data.branch.BusinessBillingNRC != null ? dataProps.data.branch.BusinessBillingNRC.toUpperCase() : "--"}}</div>
            <hr />
            <div style="display: flex; justify-content: center; margin-top: .2rem">
                <div>
                    <b>Fecha emisión:</b> {{ dataProps.data.header.InvoiceDate }}
                </div>
            </div>
            <div style="display: flex; justify-content: center; margin-top: .2rem">
                <div>
                    <b>Correlativo:</b>
                    {{dataProps.data.header.ID_Invoice}}
                </div>
            </div>
            <div v-if="!isBatresHernandez" style="display: flex; justify-content: center; margin-top: .2rem">
                <div>
                    <div> 
                        <b>Vendedor </b>
                        {{dataProps.data.user.business}}
                    </div>
                </div>
            </div>
            <div  style="display: flex; justify-content: center; margin-top: .2rem">
                <div>
                    <div> 
                        <b>Cliente </b>
                        {{ dataProps.data.header?.InvoiceName ?? '' }}
                    </div>
                </div>
            </div>
            <div  style="display: flex; justify-content: center; margin-top: .2rem">
                <div>
                    <div> 
                        <b>Dirección: </b>
                        {{ dataProps.data.header?.InvoiceAddress ?? '' }}
                    </div>
                </div>
            </div>
            <br />
            <hr />
            <div v-for="(item, index) in dataProps.data.body" :key="index" style="margin-top: .2rem">
                
                <div style="margin-left:.5rem">
                <span v-if="!isElProveedor">
                    {{ item.ID_Item }} 
                </span> {{ item.ItemDescription }}
                </div>
                <div  style="margin-left:.8rem">
                {{ item.ItemQuantity + ' X '  + numberWithCommas(parseFloat(item.ItemUnitPrice).toFixed(2)) + ' = ' +  numberWithCommas(parseFloat(item.ItemGravada).toFixed(2)) }}
                </div>
                
            </div>
            <div style="margin-top:1rem; margin-left:.5rem; display:flex">
                Sub total 
                <div style="margin-left:7rem">
                    {{dataProps.data.header.InvoiceCurrency}}
                    {{numberWithCommas(parseFloat(dataProps.data.header.InvoiceSubTotalVentas).toFixed(2))}}
                </div>
            </div>
            <div style="margin-top:.2rem; margin-left:.5rem; display:flex">
                <b>Total</b>
                <div style="margin-left:8.6rem">
                    <b>{{dataProps.data.header.InvoiceCurrency}}</b>
                    <b>{{numberWithCommas(parseFloat(dataProps.data.header.InvoiceTotalPagar).toFixed(2))}}</b>
                </div>
            </div>
            <div style="margin-top: 8px;">
                <GuaranteePrintBlock
                    :html="dataProps.guaranteeHtml"
                    :business-id="dataProps.businessId"
                    :branch-id="dataProps.branchId"
                    guarantee-type="COMPROBANTE"
                    font-size="9pt"
                />
            </div>
            <!-- espacio en blanco al finalizar factura de ticket -->
            <div>&nbsp;</div>
            <div>&nbsp;</div>
            <div>&nbsp;</div>
            <div  
              style=" width: 100%; text-align: center; text-wrap: nowrap; text-overflow: ellipsis; overflow: hidden;"
            >
              -----------------------------------------------------------------------------------------
            </div>
        </div>
    </div>        
</template>

<script>

import { addFormatToNIT, addFormatNRC } from "../../helpers/misc"
import { numberWithCommas } from "../../helpers/money";
import GuaranteePrintBlock from "@/components/ReportsAndPrintings/GuaranteePrintBlock.vue";

export default {
    name: "PrintPosTk",
    props: ['dataProps'],
    components: {
        GuaranteePrintBlock,
    },
    data() {
        return {
            header: null,
            footer: null,
            loading: false,
            numPages: 0,
            mailLabel: null,
            valuesRows: [],
            urlQr: null,
            typePrint: 0,
            keyMaster: JSON.parse(localStorage.getItem("user"))?.keymaster ?? '',
        }
    },
    computed: {
        BillingNrc() {
            return addFormatNRC(this.dataProps.data.branch.BusinessBillingNRC)
        },
        BillingNit() {
            return addFormatToNIT(this.dataProps.data.branch.BusinessBillingNIT)
        },
        isElProveedor(){
            return ['27a3c7545503830ee33ce445986e7899', 'c9efbf453194b3947aa53fcfd0ed8d4c'].includes(this.keyMaster);
        },
        isBatresHernandez(){
            return ['6ea5d856664104dfa4311d0c735cf8c4'].includes(this.keyMaster);
        }
     
    },
    methods: {
        numberWithCommas(x) {
            return numberWithCommas(x);
        },
        getHeaderFooter() {
            let search = {};
            search.ID_business = JSON.parse(localStorage.getItem("user")).businessid || ""
            search.ID_branch = JSON.parse(localStorage.getItem("user")).branch || ""
            this.$API.HF.getHF(search).then((data) => {
                let header = [], footer = [];
                header = data.filter((x) => x.State == '1' && x.Type == 'Header');
                this.header = header.length > 0 ? JSON.parse(header[0].Body).html : '';
                this.header = this.header.replace(/(\n)/gm, "");
                footer = data.filter((x) => x.State == '1' && x.Type == 'Footer');
                this.footer = footer.length > 0 ? JSON.parse(footer[0].Body).html : '';
            })
        },

        calculatePagesOfDoc() {
            let pages = 0
            let rows = 0
            this.valuesRows[pages] = []

            try{
                if(this.dataProps.data.branch.BusinessBillingNRC == '3213715' || this.dataProps.data.branch.BusinessBillingNRC == '2201050') {
                    this.typePrint = 1
                    //One page
                    if(this.dataProps.data.body.length <= 24){
                        for(let i = 0; i < this.dataProps.data.body.length; i++){
                            rows++
                            this.valuesRows[pages].push(this.dataProps.data.body[i])
                        }    
                    }
                    else{
                        for(let i = 0; i < this.dataProps.data.body.length; i++){
                            if(rows < 29 && (i !== this.dataProps.data.body.length - 1)){
                                rows++
                                this.valuesRows[pages].push(this.dataProps.data.body[i])
                            }
                            else if(rows <= 24){
                                rows++
                                this.valuesRows[pages].push(this.dataProps.data.body[i])
                            }
                            else{
                                this.valuesRows[pages].push(this.dataProps.data.body[i])
                                pages++
                                rows = 0
                                this.valuesRows[pages] = []
                            }
                        }
                    }
                }
                else{
                    this.typePrint = 0
                    //Cuando es solo una página
                    if(this.dataProps.data.body.length <= 34){
                        for(let i = 0; i < this.dataProps.data.body.length; i++){
                            rows++
                            this.valuesRows[pages].push(this.dataProps.data.body[i])
                        }    
                    }
                    else{
                        for(let i = 0; i < this.dataProps.data.body.length; i++){
                            if(rows < 39 && (i !== this.dataProps.data.body.length - 1)){
                                rows++
                                this.valuesRows[pages].push(this.dataProps.data.body[i])
                            }
                            else if(rows <= 34){
                                rows++
                                this.valuesRows[pages].push(this.dataProps.data.body[i])
                            }
                            else{
                                this.valuesRows[pages].push(this.dataProps.data.body[i])
                                pages++
                                rows = 0
                                this.valuesRows[pages] = []
                            }
                        }
                    }
                }
                
            }
            catch(err) {
                alert(err)
            }
            pages = pages + 1
            this.numPages = pages
        },
        assignCuerpoDocumento() {
            this.dataProps.data.header.jsonMH.cuerpoDocumento = this.dataProps.data.body.map( ( item, index ) => ( {
                "descripcion": item.ItemDescription,
                "montoDescu": item.ItemDiscount,
                "codigo": item.ID_Item,
                "ventaGravada": item.ItemGravada,
                "ivaItem": item.ItemIva,
                "ventaNoSuj": item.ItemNoSuj,
                "ventaExenta": item.ItemExenta,
                // "tributos": null,
                "numItem": index + 1,
                "noGravado": item.ItemNoGravada,
                "psv": item.ItemPsv,
                // "tipoItem": 3,
                // "codTributo": null,
                "uniMedida": item.ItemMeasureUnit,
                // "numeroDocumento": null,
                "cantidad": item.ItemQuantity,
                "precioUni": item.ItemUnitPrice
            } ) )
        },
    }
}
</script>

<style scoped>
    .u-row .u-col-100{
        width: 100% !important;
    }
    .btnclean{
        border-radius: 15px;
        border: 1px solid white;
  background-color: #F29D35 !important;
  color: white !important;
}
    .btnclose{
        border-radius: 15px;
        border: 1px solid white;
        background-color: rgb(255, 38, 38) !important;
        color: white !important;
       
    }

    * {
        font-family: Arial, Helvetica, sans-serif !important;
    }

 

</style>
